import React from 'react';
import styles from './index.module.scss';

const PostTitleV1 = ({ contentText, contentTag, contentName }) => {

  if (!contentText || contentText === 'none') {
    return null;
  }

  return (
    <div className={styles.postTitleV1}>
      <div className={styles.titleContainer}>
        <h3 className={styles.title}>
          {contentText?.split('\n').map((line, lineIndex) => (
            <React.Fragment key={lineIndex}>
              {line}
              {lineIndex < contentText.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </h3>
        {contentName && contentName !== 'заголовок' && (
          <p className={styles.contentName}>{contentName}</p>
        )}
      </div>
    </div>
  );
};

export default PostTitleV1;
